import { lazy, type FC } from 'react';

import createConverter, { CreateConverterProps } from '@/components/hoc/createConverter';

const AdvertisingSection = lazy(() => import('@/components/conversion/footers/UniversalFooter'));

const UniversalConverter: FC<CreateConverterProps> = ({ children }) => {
  return (
    <div className="tw-relative tw-bg-white tw-py-5 tw-p-5 sm:tw-p-[32px] tw-border-3 tw-border-ui-light-grey tw-rounded-t-footer">
      {children}
    </div>
  );
};

export default createConverter(
  UniversalConverter,
  'universal',
  {
    showConvertOcrButton: true,
  },
  AdvertisingSection
);
